import { render, staticRenderFns } from "./hi-upload-file.vue?vue&type=template&id=2945f9c4"
import script from "./hi-upload-file.vue?vue&type=script&lang=ts"
export * from "./hi-upload-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports